<template>
  <div @click="onClick()" class="cert-home-content-card-parent w-100">
    <div class="cert-home-content-card cert-alert w-100" :class="!small?' p-xl-4':'p-2 cert-small'">
      <div class="cert-img" :class="!small?'d-none d-xl-flex':'d-none'">
        <img v-if="image!=null" :src="image"/>
      </div>
      <div class="d-flex flex-row w-100">
        <div class="cert-img cert-sm my-auto" :class="!small?'d-flex d-xl-none':'d-flex cert-small'">
          <img v-if="image!=null" :src="image"/>
        </div>
        <div class="">
          <div v-if="this.title!=null" class="cert-title" :class="!small?'mt-xl-4 mb-xl-2':'cert-small'">
           {{ this.effectiveTitle }}
          </div>
          <div v-if="date!=null" class="cert-text" :class="!small?'':'cert-small'">
            {{ date }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "CertAlertCard",
  props: {
    id: String,
    title: String,
    date: String,
    image: String,
    type: String,
    small: {
      type: Boolean,
      value: false,
    },
    isAdvisory: {
      type: Boolean,
      value: false,
    },
  },
  components: {},
  data() {
    return {
      effectiveTitle: null,
    };
  },
  methods: {
    onClick() {
      this.$router.push({name: `Alert`, params: {id: this.id, type: this.type}})
    },
    updateTitle() {
      this.effectiveTitle = this.title.substring(0, 5);
      if (this.effectiveTitle.toLowerCase() === "alert")
        this.effectiveTitle = this.title.substring(6);
      else if (this.effectiveTitle.toLowerCase() === "advis")
        this.effectiveTitle = this.title.substring(9);
      else
        this.effectiveTitle = this.title
    }
  },
  created() {
    this.updateTitle();
  },
  watch: {
    title(newValue, oldValue) {
      if (newValue === oldValue)
        return;
      this.updateTitle();
    }
  }
}
</script>